import { createTRPCProxyClient } from '@trpc/client';
import type { AppRouter } from '../server/api/root.ts';
import { getTRPCClientConfig } from './api.ts';

const trpcClient = createTRPCProxyClient<AppRouter>(getTRPCClientConfig());

export { trpcClient };
